import { FunctionComponent, HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../utilities/cn';

export type StatsPillStatus = 'pass' | 'fail';

const STATUS_CLASSES: Record<
  StatsPillStatus,
  { container: string; dot: string; value: string }
> = {
  pass: {
    container: 'border-emerald-100 bg-emerald-50/40 text-emerald-700',
    dot: 'bg-emerald-500',
    value: 'text-emerald-500',
  },
  fail: {
    container: 'border-red-100 bg-red-50/40 text-red-700',
    dot: 'bg-red-500',
    value: 'text-red-500',
  },
};

export interface StatsPillProps extends HTMLAttributes<HTMLDivElement> {
  label: string;
  value: ReactNode;
  total?: ReactNode;
  status?: StatsPillStatus;
  pulse?: boolean;
}

const StatsPill: FunctionComponent<StatsPillProps> = ({
  label,
  value,
  total,
  status = 'pass',
  pulse = false,
  className,
  ...props
}) => {
  const colors = STATUS_CLASSES[status];

  return (
    <div
      className={cn(
        'flex items-center space-x-2 rounded-lg border px-3 py-1.5 text-xs shadow-sm transition-all duration-300',
        colors.container,
        className,
      )}
      {...props}
    >
      <span
        className={cn('h-2 w-2 rounded-full', colors.dot, pulse && 'animate-pulse')}
      />
      <span className="font-medium">{label}:</span>
      <span className="font-bold">
        {value}
        {total != null ? (
          <span className={cn('font-normal', colors.value)}> / {total}</span>
        ) : null}
      </span>
    </div>
  );
};

export default StatsPill;
